// extracted by mini-css-extract-plugin
export default {"datePicker":"BDatePicker-module_datePicker_f07de70f"};